import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import {Button,Grid,TextField} from '@material-ui/core';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from './Card'
import './card.css';
import Form from './Form';

const CardList = ({note, setNote}) => {
    return(
        <div className="container">
            <ul>
                { note.map(note1 => (
                    <Card 
                        text={note1.text} 
                        key={note1.id} 
                        note={note} 
                        setNote={setNote} 
                        note1 = {note1}
                    />
                )) }
            </ul>
        </div>
    );   
}

export default CardList;